// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { CommunicationPricingOperationsService } from '../generated/api/communicationPricingOperations.service';

@Injectable({ providedIn: 'root' })
export class CommunicationPricingOperationsClientService {
  constructor(private readonly client: CommunicationPricingOperationsService) {}
  // <generated-client-wrappers:methods>
  current(
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.CommunicationPricingVersionDetails> {
    if (!this.client)
      throw new Error('CommunicationPricingOperationsService is not available');
    return this.client.communicationPricingOperationsCurrent(
      'body',
      reportProgress,
      options,
    );
  }

  publish(
    request: WrapperApi.CommunicationPricingPublication,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.CommunicationPricingPublicationReceipt> {
    if (!this.client)
      throw new Error('CommunicationPricingOperationsService is not available');
    return this.client.communicationPricingOperationsPublish(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  version(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.CommunicationPricingVersionDetails> {
    if (!this.client)
      throw new Error('CommunicationPricingOperationsService is not available');
    return this.client.communicationPricingOperationsVersion(
      id,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
